import { TextStyle, TextWhitespace } from '@shared/models/types/ui/app-text'

export const TEXT_STYLES: Record<TextStyle, string> = {
  uppercase: 'tw-uppercase',
  lowercase: 'tw-lowercase',
  capitalize: 'tw-capitalize',
  'normal-case': 'tw-normal-case',
}

export const WHITESPACES: Record<TextWhitespace, string> = {
  normal: 'tw-whitespace-normal',
  nowrap: 'tw-whitespace-nowrap',
  pre: 'tw-whitespace-pre',
  'pre-line': 'tw-whitespace-pre-line',
  'pre-wrap': 'tw-whitespace-pre-wrap',
  'break-spaces': 'tw-whitespace-break-spaces',
  truncate: 'tw-truncate',
}
